export const SET_ORCHESTRATION_STATE = 'SET_ORCHESTRATION_STATE';

export function setOrchestration(orchestration) {
  return { orchestration, type: SET_ORCHESTRATION_STATE };
}
